import type { FC } from 'react';
import React, { useEffect, useState } from 'react';
import { match } from 'variant';
import { useAppDeploymentTopologyUpdater } from './useAppDeploymentTopologyUpdater.js';
import { useERCManifestUpdateNotifier } from './useERCManifestUpdateNotifier.js';
import { ScreenState } from './screen-state.js';
import { SiteSelectorScreen } from './SiteSelectorScreen.js';
import { HomeScreen } from './HomeScreen.js';
import { useDevEnvironment } from '../DevEnvironment.js';
import { useProjectModel } from '../../../model.js';

export const AppDev: FC = () => {
  const [screen, setScreen] = useState<ScreenState>(ScreenState.Home());
  const {
    model: { pluginsInterface },
  } = useProjectModel();
  const { devCenterWatcher } = useDevEnvironment();

  useAppDeploymentTopologyUpdater();
  useERCManifestUpdateNotifier();

  useEffect(() => {
    return devCenterWatcher.onManifestUpdated(({ versionOverrideId }) => {
      void pluginsInterface?.eventsEmitter.emit('dc-updated', {
        overrideId: versionOverrideId,
      });
    });
  }, [devCenterWatcher, pluginsInterface]);

  return match(screen, {
    Home: () => <HomeScreen onScreenChange={setScreen} />,
    SiteSelector: () => <SiteSelectorScreen onScreenChange={setScreen} />,
  });
};
